import BreakoutModule from './BreakoutModule'

export default BreakoutModule
